import HeroSection from "./components/HeroSection";
import CategoryNav from "./components/CategoryNav";
import FeaturedArticles from "./components/FeaturedArticles";
import FAQSection from "./components/FAQSection";

export default function Home() {
  const websiteJsonLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "打屁股作文",
    url: "https://www.dapiguzuowen.com",
    description: "专注打屁股作文主题，提供经典校园与家庭惩罚场景的作文素材、范文赏析及写作技巧。",
    potentialAction: {
      "@type": "SearchAction",
      target: {
        "@type": "EntryPoint",
        urlTemplate: "https://www.dapiguzuowen.com/search?q={search_term_string}",
      },
      "query-input": "required name=search_term_string",
    },
  };

  const organizationJsonLd = {
    "@context": "https://schema.org",
    "@type": "EducationalOrganization",
    name: "打屁股作文",
    url: "https://www.dapiguzuowen.com",
    description: "专注打屁股作文主题的写作素材与技巧平台",
    address: {
      "@type": "PostalAddress",
      addressLocality: "北京",
      addressRegion: "北京",
      addressCountry: "CN",
    },
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "400-888-6666",
      contactType: "customer service",
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationJsonLd)}</script>
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedArticles />
        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
            <div className="bg-primary-500 rounded-2xl p-8 md:p-12 text-center relative overflow-hidden">
              <div className="absolute inset-0 opacity-10">
                <div className="absolute top-0 right-0 w-64 h-64 rounded-full bg-background-50/20 -translate-y-1/2 translate-x-1/4"></div>
                <div className="absolute bottom-0 left-0 w-48 h-48 rounded-full bg-background-50/20 translate-y-1/2 -translate-x-1/4"></div>
              </div>
              <div className="relative z-10">
                <h2 className="text-2xl md:text-3xl font-bold text-background-50 mb-3">
                  想让你的作文更真实动人？
                </h2>
                <p className="text-sm md:text-base text-background-50/80 max-w-md mx-auto mb-6">
                  学习专业的惩罚场景描写技巧，让你的记叙文情感丰富、细节饱满，轻松打动阅卷老师
                </p>
                <a
                  href="/category/xijie-kehua"
                  className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-primary-600 rounded-full font-medium text-sm whitespace-nowrap hover:bg-background-100 transition-all duration-300 cursor-pointer shadow-lg"
                >
                  <i className="ri-rocket-line"></i>
                  立即开始学习
                </a>
              </div>
            </div>
          </div>
        </section>
        <FAQSection />
      </main>
    </>
  );
}